import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const AuditLogsExportDropdown = ({ isLoading = false, onExport }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleOutsideClick = event => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);

  useEffect(() => {
    if (isLoading) {
      setIsOpen(false);
    }
  }, [isLoading]);

  const handleExport = format => {
    setIsOpen(false);
    onExport(format);
  };

  return (
    <div className="audit-logs__export-dropdown" ref={containerRef}>
      <button
        type="button"
        className="btn btn--info audit-logs__export-btn"
        onClick={() => setIsOpen(prev => !prev)}
        disabled={isLoading}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        <i className="fas fa-file-export audit-logs__export-btn-icon" aria-hidden="true" />
        <span className="audit-logs__export-btn-label">
          {isLoading ? "Exporting..." : "Export"}
        </span>
        <i
          className={`fas fa-chevron-${isOpen ? "up" : "down"} audit-logs__export-btn-caret`}
          aria-hidden="true"
        />
      </button>
      {isOpen ? (
        <div className="audit-logs__export-menu" role="menu">
          <button
            type="button"
            className="audit-logs__export-menu-item"
            onClick={() => handleExport("xlsx")}
            disabled={isLoading}
          >
            <span>Export Excel (.xlsx)</span>
            <i className="fas fa-file-excel" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="audit-logs__export-menu-item"
            onClick={() => handleExport("csv")}
            disabled={isLoading}
          >
            <span>Export CSV (.csv)</span>
            <i className="fas fa-file-csv" aria-hidden="true" />
          </button>
        </div>
      ) : null}
    </div>
  );
};

AuditLogsExportDropdown.propTypes = {
  isLoading: PropTypes.bool,
  onExport: PropTypes.func.isRequired
};

export default AuditLogsExportDropdown;
